<td-alert *ngIf="show" state="info" class="mb-4" (click)="update()">
    <div class="my-3 d-flex align-items-center">
        <span class="flex-grow-1" *transloco="let t">{{ t('app.update-available') }}</span>
        <fa-icon class="mx-2" size="2x" icon="redo-alt"></fa-icon>
    </div>
</td-alert>
